"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RT_CACHE = Symbol("RT:CACHE");
class Utils {
    static get(obj, sym) {
        return obj[sym];
    }
    static set(obj, sym, value) {
        Object.defineProperty(obj, sym, { value, configurable: false, enumerable: false });
        return obj;
    }
    static freezeSet(obj) {
        if (obj instanceof Set) {
            const pd = { configurable: false, enumerable: false, get: undef, set: undef };
            Object.defineProperty(obj, "add", pd);
            Object.defineProperty(obj, "delete", pd);
            Object.defineProperty(obj, "clear", pd);
            Object.freeze(obj);
        }
    }
    static freezeMap(obj) {
        if (obj instanceof Map) {
            const pd = { configurable: false, enumerable: false, get: undef, set: undef };
            Object.defineProperty(obj, "set", pd);
            Object.defineProperty(obj, "delete", pd);
            Object.defineProperty(obj, "clear", pd);
            Object.freeze(obj);
        }
    }
    static copyAllProps(source, target) {
        for (const prop of Object.getOwnPropertyNames(source))
            Utils.copyProp(source, target, prop);
        for (const prop of Object.getOwnPropertySymbols(source))
            Utils.copyProp(source, target, prop);
        return target;
    }
    static copyProp(source, target, prop) {
        // let pd = Object.getOwnPropertyDescriptor(source, prop);
        // if (pd) {
        //   pd.writable = true;
        //   Object.defineProperty(target, prop, pd);
        // }
        return target[prop] = source[prop];
    }
    static equal(oldValue, newValue) {
        return newValue === oldValue;
    }
    static valueHint(value) {
        let result = "";
        if (Array.isArray(value))
            result = `Array(${value.length})`;
        else if (value instanceof Set)
            result = `Set(${value.size})`;
        else if (value instanceof Map)
            result = `Map(${value.size})`;
        else if (value === exports.RT_CACHE)
            result = `<renew>`;
        else if (value !== undefined && value !== null)
            result = value.toString().slice(0, 20);
        else
            result = "◌";
        return result;
    }
    static hasAllFlags(flags, required) {
        return (flags & required) === required;
    }
}
exports.Utils = Utils;
/* istanbul ignore next */
Utils.different = function (oldValue, newValue) {
    return !Utils.equal(oldValue, newValue); // to be redefined by Cache implementation
};
/* istanbul ignore next */
function undef(...args) {
    throw new Error("this method should never be called");
}
exports.undef = undef;
/* istanbul ignore next */
function rethrow(error) {
    throw error;
}
exports.rethrow = rethrow;
function all(promises) {
    return __awaiter(this, void 0, void 0, function* () {
        let error;
        const result = yield Promise.all(promises.map(x => x.catch(e => { error = error || e; return e; })));
        if (error)
            throw error;
        return result;
    });
}
exports.all = all;
/* istanbul ignore next */
function sleep(timeout) {
    return new Promise(function (resolve) {
        setTimeout(resolve.bind(null, () => resolve), timeout);
    });
}
exports.sleep = sleep;
